import axios from 'axios'
import $ from 'jquery';
import  {CORS_URL,API_URL} from "../config"


export  function getList(response ='') {
    let perfData =  {'name':response.attribute.name,
                    'month':response.attribute.month,
                    'parameters':response.attribute.parameters,
                    'score':response.attribute.score,
                    'year':response.attribute.year,
                    'batch_best_score':response.current_parameter.batch_best_score,
                    'graph' : response.current_parameter.graph_data,
                    'player_name' : response.player.name,
                    //
                   }
    for(let im=0;im<perfData.parameters.length;im++) {
        if(perfData.parameters[im].is_selected === true) {
            perfData.parameter_selected = { value: perfData.parameters[im].parameter_id, label: perfData.parameters[im].name }
        }
    }
    return {
        type : 'performance',
        payload : {
            performance : perfData,
            isLoaded : true,
            error : false
        }
    }
}



export function showError(error= "Error!!") {
    return {
        type : 'Error',
        payload : {
            performance : error,
            isLoaded : true,
            error : true
        }
    }
}



export function performanceApiRequest(getData = null) {
    document.getElementById('content').classList.add('loader');
    let month = new Date().getMonth();
    let year = new Date().getFullYear();
    let parameter_id = '';
    let attribute_id = 1;

    if(getData !== null) {
        if(typeof getData.parameter_id !== 'undefined' && getData.parameter_id > 0 && (getData.oldAttribute === getData.attribute_id) ){
            parameter_id = '&parameterId='+getData.parameter_id;
        }
        month = getData.month;
        year = getData.year;

        if(typeof getData.attribute_id !== 'undefined' && getData.attribute_id !='') {
            attribute_id = getData.attribute_id.value
        }
    }

    let headers = {
      "Access-Control-Allow-Origin": "*",
      "x-authorization" : localStorage.getItem('authToken')
    }
    let batch_id = document.getElementById("batch_id").value;
    let player_id = document.getElementById("player_id").value;
    let academy_id = document.getElementById("academy_id").value;
    return dispatch => {
        $.ajax({
            url : CORS_URL+API_URL+'/performance/'+attribute_id+'/attribute-detail?batch_id='+batch_id+'&month='+month+'&year='+year+'&player_id='+player_id+parameter_id,
            crossDomain: true,
            type: "GET",
            headers: {
                "x-authorization" : "Bearer  eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNSIsInNjb3BlcyI6WyJQTEFZRVIiXSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwLyIsImlhdCI6MTU2NDQ5MTAxMiwiZXhwIjo1MjI1NjI4NDQ5MTAxMn0.TkO5W1tQ4PpxvyiTC0h86LmAXm4ffnXgV1uqxF0dP6U52eYxa8Vi0w4i3xDv1lnEMP9lufHR8OxtljiHgLxtwQ",
            },

            success(response) {
                if(response.code === 200) {
                    dispatch(getList(response.data))
                } else {
                    dispatch(showError());
                }
                document.getElementById('content').classList.remove('loader');
            },
            error() {
                dispatch(showError());
                document.getElementById('content').classList.remove('loader');
            }
        })
    }
}

export function performanceParameterChange(selectedOption,performance) {
    let perfData = performance.performance;
    perfData.parameter_selected = selectedOption;
        return {
            type : 'performance',
            payload : {
                performance : perfData,
                isLoaded : true,
                error : false
            }
        }
}

export function performanceMonthChange(month,year,performance) {
    let perfData = performance.performance;
    perfData.year = year;
    perfData.month = month;
        return {
            type : 'performance',
            payload : {
                performance : perfData,
                isLoaded : true,
                error : false
            }
        }
}


export function attributeApiRequest() {
    let headers = {
      "Access-Control-Allow-Origin": "*",
      "x-authorization" : localStorage.getItem('authToken')
    }
    let batch_id = document.getElementById("batch_id").value;
    return dispatch => {
        $.ajax({
            url : CORS_URL+API_URL+'/global/batch/progress-attributes?batch_id='+batch_id,
            crossDomain: true,
            type: "GET",
            headers: {
                "x-authorization" : "Bearer  eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNSIsInNjb3BlcyI6WyJQTEFZRVIiXSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwLyIsImlhdCI6MTU2NDQ5MTAxMiwiZXhwIjo1MjI1NjI4NDQ5MTAxMn0.TkO5W1tQ4PpxvyiTC0h86LmAXm4ffnXgV1uqxF0dP6U52eYxa8Vi0w4i3xDv1lnEMP9lufHR8OxtljiHgLxtwQ",
            },

            success(response) {
                if(response.code === 200) {
                    dispatch(getAttributeList(response.data))
                } else {
                    dispatch(showError());
                }
            },
            error() {
                dispatch(showError());
            }
        })
    }
}

export function getAttributeList(rData) {
        return {
            type : 'attribute',
            payload : {
                attribute : rData.attributes,
                isLoaded : true,
                error : false
            }
        }
}